module.exports = {
  authServer: 'auth.entrinsia.net',
  apiServer: 'api.entrinsia.net'
}